var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.show)?_c('div',{staticClass:"TableFilter"},[_c('span',[_c('b',[_vm._v("Filtered By "+_vm._s(_vm.type))]),_vm._v(": "+_vm._s(_vm.term))]),_c('v-btn',{attrs:{"x-small":"","color":"secondary"},on:{"click":_vm.clearFilter}},[_c('v-icon',{attrs:{"left":"","x-small":""}},[_vm._v(" fas fa-times-circle ")]),_vm._v(" Clear ")],1)],1):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }